import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import contactBg from "../../images/bg/contact-bg.png";
import gifShape from "../../images/icon/b10c3e43e836d32554bf.gif";

const ContactSection: React.FC = () => {
  const { t } = useTranslation();
  return (
    <section
      className="contact-section pt-150 pb-140 bg_img"
      style={{ backgroundImage: `url(${contactBg})` }}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="cta-content text-center">
              <div className="sec-title mb-40">
                <span className="sub-title mb-15">{t('contact.subtitle')}</span>
                <h2 className="title horizontal-shape">
                  {t('contact.titlePrefix')}{" "}
                  <img src={gifShape} alt="animated-shape" /> {t('contact.titleSuffix')}
                </h2>
                <p className="mt-20" style={{ color: 'var(--color-gray)', fontSize: '18px', maxWidth: '600px', margin: '20px auto 0' }}>
                  {t('contact.ctaDescription')}
                </p>
              </div>

              <div className="cta-stats d-flex justify-content-center gap-5 mb-50">
                <div className="cta-stat-item text-center">
                  <h3 style={{ color: 'var(--color-primary)', fontSize: '48px', fontWeight: '700', marginBottom: '8px' }}>{t('contact.stat1')}</h3>
                  <p style={{ color: 'var(--color-gray)', fontSize: '14px' }}>{t('contact.stat1Label')}</p>
                </div>
                <div className="cta-stat-item text-center">
                  <h3 style={{ color: 'var(--color-primary)', fontSize: '48px', fontWeight: '700', marginBottom: '8px' }}>{t('contact.stat2')}</h3>
                  <p style={{ color: 'var(--color-gray)', fontSize: '14px' }}>{t('contact.stat2Label')}</p>
                </div>
                <div className="cta-stat-item text-center">
                  <h3 style={{ color: 'var(--color-primary)', fontSize: '48px', fontWeight: '700', marginBottom: '8px' }}>{t('contact.stat3')}</h3>
                  <p style={{ color: 'var(--color-gray)', fontSize: '14px' }}>{t('contact.stat3Label')}</p>
                </div>
              </div>

              <div className="cta-buttons d-flex justify-content-center gap-3 flex-wrap">
                <Link className="thm-btn agency-btn" to="/register">
                  <span className="text">{t('hero.cta')}</span>
                  <span className="arrow">
                    <span className="arrow-icon">
                      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="5.06592" y="19.9785" width="20.5712" height="2.61221" transform="rotate(-40.2798 5.06592 19.9785)" fill="white"/>
                        <rect x="7.97095" y="7.24463" width="2.61221" height="2.61221" transform="rotate(-40.2798 7.97095 7.24463)" fill="white"/>
                        <rect x="11.6523" y="7.54834" width="2.61221" height="2.61221" transform="rotate(-40.2798 11.6523 7.54834)" fill="white"/>
                        <rect x="15.334" y="7.85205" width="2.61221" height="2.61221" transform="rotate(-40.2798 15.334 7.85205)" fill="white"/>
                        <rect x="18.7119" y="11.8374" width="2.61221" height="2.61221" transform="rotate(-40.2798 18.7119 11.8374)" fill="white"/>
                        <rect x="19.0156" y="15.5765" width="2.61221" height="2.61221" transform="rotate(-40.2798 19.0156 15.5765)" fill="white"/>
                      </svg>
                      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="5.06592" y="19.9785" width="20.5712" height="2.61221" transform="rotate(-40.2798 5.06592 19.9785)" fill="white"/>
                        <rect x="7.97095" y="7.24463" width="2.61221" height="2.61221" transform="rotate(-40.2798 7.97095 7.24463)" fill="white"/>
                        <rect x="11.6523" y="7.54834" width="2.61221" height="2.61221" transform="rotate(-40.2798 11.6523 7.54834)" fill="white"/>
                        <rect x="15.334" y="7.85205" width="2.61221" height="2.61221" transform="rotate(-40.2798 15.334 7.85205)" fill="white"/>
                        <rect x="18.7119" y="11.8374" width="2.61221" height="2.61221" transform="rotate(-40.2798 18.7119 11.8374)" fill="white"/>
                        <rect x="19.0156" y="15.5765" width="2.61221" height="2.61221" transform="rotate(-40.2798 19.0156 15.5765)" fill="white"/>
                      </svg>
                    </span>
                  </span>
                </Link>
                <Link
                  className="thm-btn agency-btn"
                  to="/contact"
                  style={{ background: 'transparent', border: '1px solid var(--color-border)' }}
                >
                  <span className="text" style={{ background: 'transparent', color: 'var(--color-white)' }}>{t('contact.salesButton')}</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
